import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  ApplicationState,
  CaseSettingsActionCreators,
  VehicleActionCreators
} from '../../store';
import { withSnackbar } from 'notistack';
import {
  CardContent,
  Button,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  Box
} from '@material-ui/core';
import { AppContext, ApplicationContext } from '../../context/Contexts';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { ButtonGroup, Card, CardFooter } from 'reactstrap';
import { ScaleLoader } from 'react-spinners';
import { IReferentialService } from '../../services/Interfaces/IReferentialService';
import { MavoImageUploadSizeLimit, MavoVehicelAttachementTypeCodeEnum, MavoVehicleStatusCodeEnum, RefConstants, disabledMavoVehicleStatuses } from '../../helpers/Constants';
import DescriptionIcon from '@material-ui/icons/Description';
import { IReferential } from '../../interfaces/IReferential';
import _ from 'lodash';
import { IVehicleService } from '../../services/Interfaces/IVehicleService';
import { MavoVehicleAttachment } from '../../interfaces/Vehicle';
import { MavoVehicleDetailsProps } from '../cases/vehicleDetails/MavoVehicleDetailsProps';
import { MavoVehicleActionCreators } from '../../store/actions/MavoVehicle';
import { IMavoAttachmentDataContainerProps } from '../cases/vehicleDetails/IMavoAttachmentDataContainerProps';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import GetAppIcon from '@material-ui/icons/GetApp';
import { isNullOrUndefined } from 'util';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import FileViewer from 'react-file-viewer';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileSaver from 'file-saver';
import PreviewAttachment from './PreviewAttachment';
import MuiTheme from '../../theme';


interface IMavoAttachmentDataContainerState {
  isLoading: boolean;
  executing: boolean;
  attachmentTypeList: IReferential[];
  previewAttachFile: any;
  previewAttachFileExtension: string;
  isDialogOpen: boolean;
  currentIndex: number,
  attachmentTypeId: number;
}

class MavoAttachmentDataContainer extends React.PureComponent<
  IMavoAttachmentDataContainerProps,
  IMavoAttachmentDataContainerState
> {
  private translatorService!: ITranslatorService;
  private vehicleService!: IVehicleService;
  private appReferentialService!: IReferentialService;

  static contextType = ApplicationContext;
  static displayName = 'MavoAttachmentDataContainer';

  state = {
    isLoading: false,
    executing: false,
    isValuationOpen: false,
    isOpen: false,
    dialogVisible: false,
    attachmentTypeList: [],
    previewAttachFile: '',
    previewAttachFileExtension: '',
    isDialogOpen: false,
    currentIndex: 0,
    attachmentTypeId: 0,
  } as IMavoAttachmentDataContainerState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  loadData = async () => {
    const {
      vehicleAttachmentTypeRef
    } = RefConstants;
    const [
      vehicleAttachmentTypeList,
      vehicleAttachmentList
    ] = await Promise.all([
      this.appReferentialService.Get(vehicleAttachmentTypeRef?.baseUrl),
      this.vehicleService.GetMavoVehicleAttachments(this.props.mavoVehicleState.mavoVehicle.id)
    ]);

    let processedFiles: MavoVehicleAttachment[] = [];
    try {
      processedFiles = await Promise.all(
        vehicleAttachmentList.map(async (file) => {
          const { originalFileName, fileName } = file;
          try {
            const fileBlob = await this.vehicleService.GetMavoVehicleAttachment(fileName);
            const url = URL.createObjectURL(fileBlob);
            const extension = originalFileName.split('.').pop();
            return { ...file, url, extension };
          } catch (error) {
            return { ...file };
          }
        })
      );
    } catch (error) {
      console.error("Error processing files:", error);
      processedFiles = vehicleAttachmentList
    }

    this.props.setMavoVehicleObject({
      ...this.props.mavoVehicleState.mavoVehicle,
      mavoVehicleAttachments: processedFiles?.length > 0 ? processedFiles : vehicleAttachmentList
    })

    vehicleAttachmentTypeList.forEach((attachmentType) => {
      attachmentType.isLoading = false;
    });

    this.setState({
      isLoading: false,
      attachmentTypeList: vehicleAttachmentTypeList,
    });
  };


  isDisabled = (): boolean => {
    //1.3	Actualizare/modificare
    if (this.props.mavoVehicleState.mavoVehicle.id !== 0) {
      //daca vehiculul este in stare “Licitatie”, se pot actualiza doar informatiile «Stare vehicul», «Despre vehicul (Dotari)» si «Poze» 
      if (this.props.mavoVehicleState.mavoVehicle.currentStatus!.status!.code === MavoVehicleStatusCodeEnum.LICITATIE.toString()) {
        return false;
      }
      //daca vehiculul este in orice alta stare («Comanda», «Aviz», «Factura»), nu se pot actualiza nici un fel de informatii referitoare la acest vehicul
      return disabledMavoVehicleStatuses.includes(this.props.mavoVehicleState.mavoVehicle.currentStatus!.status!.code ?? '') ? true : false;
    }
    return false;
  };


  handlePreviewAttachment = async (originalFileName: string, filename: string) => {
    try {
      const fileBlob = await this.vehicleService.GetMavoVehicleAttachment(filename);
      const url = URL.createObjectURL(fileBlob);
      const extension = originalFileName.split('.').pop();

      if (isNullOrUndefined(extension)) {
        return;
      }

      this.setState({
        previewAttachFile: url,
        previewAttachFileExtension: extension!.toLowerCase(),
        isDialogOpen: true
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderPreviewAttachment = () => {
    return (
      <FileViewer
        fileType={this.state.previewAttachFileExtension}
        filePath={this.state.previewAttachFile}
      />
    );
  };

  setAttachmentTypeList = (attachmentType: IReferential, value: boolean) => {
    const attachmentTypeList = _.cloneDeep(this.state.attachmentTypeList);
    for (let i = 0; i < attachmentTypeList.length; i++) {
      if (attachmentTypeList[i].id === attachmentType.id) {
        attachmentTypeList[i].isLoading = value;
      }
    }

    return attachmentTypeList;
  };

  /**
   * Get dimensions of any image by url
   * @param {string} url
   * @param {number} [rejectTimeout] timeout for reject
   * @return {Promise<{ width: number, height: number }>}
   */
  reactImageSize = (
    url: string,
    rejectTimeout: number
  ): Promise<{ width: number; height: number }> =>
    new Promise((resolve, reject) => {
      let timer: NodeJS.Timeout | null = null;

      const img = new Image();

      img.addEventListener('load', () => {
        if (timer) {
          clearTimeout(timer);
        }

        resolve({ width: img.width, height: img.height });
      });

      img.addEventListener('error', (event) => {
        if (timer) {
          clearTimeout(timer);
        }

        reject(`${event.type}: ${event.message}`);
      });

      img.src = url;

      if (rejectTimeout) {
        timer = setTimeout(() => reject('Timeout exception'), rejectTimeout);
      }
    });

  addWatermarkToImage = async (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          if (!ctx) return;

          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0);

          const watermarkText = "Licensed for Mavo Application Only";
          ctx.font = `${img.width / 20}px Arial`;
          ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          ctx.save();
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(-Math.PI / 4);

          ctx.fillText(watermarkText, 0, 0);

          ctx.restore();

          const outputType = file.type === "image/jpeg" ? "image/jpeg" : "image/png";
          const outputQuality = outputType === "image/jpeg" ? 0.8 : 1.0;
          canvas.toBlob(
            (blob) => {
              const ext = outputType === "image/jpeg" ? ".jpg" : ".png";
              const newFile = new File([blob!], file.name.replace(/\.\w+$/, ext), {
                type: outputType
              });
              resolve(newFile);
            },
            outputType,
            outputQuality
          );
        };

        img.onerror = (err) => {
          console.error("Eroare la încărcarea imaginii", err);
          reject(err);
        };
      };

      reader.onerror = (err) => {
        console.error("Eroare la citirea fișierului", err);
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  handleUploadAttachment = async (
    e: React.ChangeEvent<HTMLInputElement>,
    attachmentType: IReferential
  ) => {
    try {
      if (e.target.files === null) {
        return;
      }
      e.persist();

      this.setState({
        attachmentTypeList: this.setAttachmentTypeList(attachmentType, true)
      });

      const attachments: MavoVehicleAttachment[] = [];
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files![i];
        if (attachmentType.code == MavoVehicelAttachementTypeCodeEnum.IMG) {
          const fileSizeKB = file.size / 1024;
          if (fileSizeKB > MavoImageUploadSizeLimit.MaxSizeKB) {
            this.props.enqueueSnackbar(
              this.translatorService.Tranlate('MAVO_VEHICLE_IMG', 'Imaginea ') +
              file.name +
              this.translatorService.Tranlate('MAVO_VEHICLE_MAX_SIZE', 'depaseste dimensiunea maxima de 1MB.'),
              {
                variant: 'warning',
                autoHideDuration: 5000
              }
            );
            continue;
          }
        }
        let watermarkedFile = file;
        if (attachmentType.code == MavoVehicelAttachementTypeCodeEnum.IMG) {
          watermarkedFile = await this.addWatermarkToImage(file);
        }
        attachments.push({
          id: 0,
          mavoVehicleId: this.props.mavoVehicleState.mavoVehicle.id,
          attachmentTypeId: attachmentType.id,
          attachmentType: attachmentType,
          file: watermarkedFile,
          originalFileName: file.name,
        } as MavoVehicleAttachment);
      }
      if (this.props.mavoVehicleState.mavoVehicle.id === 0) {
        this.props.setMavoVehicleObject({
          ...this.props.mavoVehicleState.mavoVehicle,
          mavoVehicleAttachments: [
            ...this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments,
            ...attachments
          ]
        });
      } else {
        if (attachments.length > 0) {
          const newFiles = await this.vehicleService.AddMavoVehicleAttachments(attachments);
          this.props.setMavoVehicleObject({
            ...this.props.mavoVehicleState.mavoVehicle,
            mavoVehicleAttachments: [
              ...this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments,
              ...newFiles
            ]
          });
        }
      }

      this.setState({
        attachmentTypeList: this.setAttachmentTypeList(attachmentType, false)
      });

      e.target.value = '';
    } catch (error) {
      console.log(error);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      e.target.value = '';
    }
  };

  handleDeleteAttachment = async (id: number, fileName: string) => {
    try {
      await this.vehicleService.RemoveMavoVehicleAttachment(fileName);

      const mavoVehicleAttachments = [...this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments];
      const index = mavoVehicleAttachments.findIndex((item) => item.id === id);
      mavoVehicleAttachments.splice(index, 1);

      this.props.setMavoVehicleObject({
        ...this.props.mavoVehicleState.mavoVehicle,
        mavoVehicleAttachments: [...mavoVehicleAttachments]
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  downloadFile = async (fileName: string, origFileName: string) => {
    const fileBlob = await this.vehicleService.GetMavoVehicleAttachment(fileName);
    FileSaver.saveAs(fileBlob, origFileName);
  };

  renderAttachments = (attachemntType: IReferential) => {
    const attachments = this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments.filter(
      (item) => item.attachmentTypeId === attachemntType.id
    );
    const attachmentsToRender = [] as any[];
    attachments.forEach((attach, index) => {
      attachmentsToRender.push(
        <div className='border col-12 col-sm-6 col-md-4 col-lg-2' key={attach?.originalFileName.split('.').pop()} style={{ margin: '10px', maxWidth: 250, maxHeight: 250 }}>
          <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', right: 0 }}>
            <IconButton
              aria-label="preview"
              color="inherit"
              className="text-primary"
              size="small"
              onClick={() => {
                if (attachemntType!.code == MavoVehicelAttachementTypeCodeEnum.IMG) {
                  this.setState({ isDialogOpen: true, currentIndex: index, previewAttachFileExtension: '', attachmentTypeId: attach.attachmentTypeId })
                } else {
                  this.handlePreviewAttachment(attach.originalFileName, attach.fileName);
                }
              }

              }
            >
              <VisibilityIcon />
            </IconButton>

            {attach.id !== 0 ? (
              <IconButton
                aria-label="download"
                color="inherit"
                className="text-primary"
                size="small"
                onClick={(e) => this.downloadFile(attach.fileName, attach.originalFileName)}
              >
                <GetAppIcon />
              </IconButton>
            ) : null}
            {attach.id !== 0 && !this.isDisabled() && !this.props.disabled ? (
              <IconButton
                aria-label="delete"
                color="inherit"
                className="text-danger"
                size="small"
                onClick={(e) => {
                  this.handleDeleteAttachment(
                    attach.id,
                    attach.fileName
                  );
                }}
              >
                <DeleteOutlineTwoToneIcon />
              </IconButton>
            ) : null}


          </div>
          <div className="card-body text-center d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%', }}>
            {attachemntType!.code == MavoVehicelAttachementTypeCodeEnum.IMG ? <img
              alt={`Preview`}
              onClick={() => { this.setState({ isDialogOpen: true, currentIndex: index, previewAttachFileExtension: '', attachmentTypeId: attach.attachmentTypeId }) }}
              className="img-fluid"
              style={{
                maxWidth: '95%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
              src={attach?.url || `data:img/png;base64,${attach?.content}`}></img> :
              <div><DescriptionIcon
                style={{ fontSize: 150 }}
                color="secondary"

              ></DescriptionIcon>
                <span style={{ color: MuiTheme.palette.primary.main }}>{attach.originalFileName}</span>
              </div>
            }
          </div>
        </div>
      );
    });

    return attachmentsToRender;
  };

  renderAttachTypeCard = (attachType: IReferential) => {
    return (<Card className="card-box w-100 shadow-none">
      <div className="card-header text-center">
        <div className="card-header--title">
          <b>
            {attachType!.displayName}
          </b>
        </div>
      </div>

      <CardContent className="p-3 flex-grow-1">
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={attachType?.isLoading} />
        </div>
        {!attachType?.isLoading ? (
          <div className="file-manager-wrapper h-100">
            {this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments.filter(
              (item) => item.attachmentTypeId === attachType?.id
            ).length !== 0 ? (

              <div className="d-flex flex-row text-center flex-wrap">{this.renderAttachments(attachType)}</div>

            ) : (
              <div className="h-100 align-self-center text-center">
                <DescriptionIcon
                  className="h-100"
                  color="primary"
                  fontSize="large"
                ></DescriptionIcon>
              </div>
            )}
          </div>
        ) : (
          ''
        )}
      </CardContent>
      {!this.isDisabled() && !this.props.disabled ? <CardFooter className="p-3 border-0">
        <ButtonGroup className="w-100">
          <Button
            variant="contained"
            color="primary"
            className="d-block w-100 text-center shadow-none"
            disabled={this.isDisabled() || this.props.disabled}
          >
            <input
              className="d-none"
              key={attachType.fileInputKey}
              id={'contained-button-file' + attachType.id}
              disabled={this.isDisabled() || this.props.disabled}
              onChange={(e) => {
                return this.handleUploadAttachment(e, attachType);
              }}
              type="file"
              accept={'image/*'}
              multiple={true}
            />
            <label
              htmlFor={'contained-button-file' + attachType.id}
              className="w-100 mb-0"
            >
              Upload
            </label>
          </Button>
        </ButtonGroup>
      </CardFooter> : <></>}
    </Card>)
  }

  renderWorkflowAttashmentTypes = () => {
    const attachImgType = this.state.attachmentTypeList.find(
      (item) => item.code === MavoVehicelAttachementTypeCodeEnum.IMG
    );
    const attachDocType = this.state.attachmentTypeList.find(
      (item) => item.code === MavoVehicelAttachementTypeCodeEnum.OTHER
    );

    return <div className="p-1 w-100" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      {attachImgType ? this.renderAttachTypeCard(attachImgType) : <></>}

      {attachDocType ? <div style={{ marginTop: 60 }}>{this.renderAttachTypeCard(attachDocType)}</div> : <></>}
    </div>
  }

  renderGalleryAttashment = () => {
    return <div className="d-flex flex-row text-center flex-wrap">
      {this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments?.map((attach, index) => {
        return <div className='border col-12 col-sm-6 col-md-4 col-lg-2' key={attach.extension} style={{ margin: '10px' }}>
          <div className="card-body text-center d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
            {attach!.attachmentType?.code == MavoVehicelAttachementTypeCodeEnum.IMG ? <img
              alt={`Preview`}
              onClick={() => { this.setState({ isDialogOpen: true, currentIndex: index, attachmentTypeId: attach.attachmentTypeId }) }}
              className="img-fluid"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
              src={attach?.url}></img> : <div><DescriptionIcon
                style={{ fontSize: 150 }}
                color="secondary"

              ></DescriptionIcon>
              <span style={{ color: MuiTheme.palette.primary.main }}>{attach.originalFileName}</span>
            </div>}
          </div>
        </div>
      })}
    </div>
  }

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false
    });
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.vehicleService = (this.context as AppContext).vehicleService;
    this.appReferentialService = (this.context as AppContext).referentialService;


    return (
      <Fragment>
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
        </div>
        {!this.state.isLoading ? (
          <div className="d-flex flex-wrap m-1">{this.renderWorkflowAttashmentTypes()}</div>
        ) : null}
        <Dialog
          onClose={this.closeDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.isDialogOpen}
          maxWidth={this.isDisabled() ? "lg" : 'md'}
          fullWidth
          fullScreen={false}
          classes={{ paper: 'dialogPaper' }}
          scroll="body"
        >
          <DialogTitle id="customized-dialog-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.translatorService.Tranlate('CASE_PREVIEW_DOC', 'Previzualizare document')}
                </Typography>
              </Grid>
              <Grid className="text-right" item xs={1}>
                <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container alignContent="center">
              <Grid item xs={12}>

                <Box height="65vh" className="text-center">
                  {this.state.previewAttachFileExtension !== '' ? this.renderPreviewAttachment() : <PreviewAttachment
                    currentIndex={this.state.currentIndex}
                    loadMavoAttachmentData={this.props.mavoVehicleState.mavoVehicle.mavoVehicleAttachments}
                    attachmentTypeId={this.state.attachmentTypeId}
                  />}
                </Box>

              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </Fragment >
    );
  }
}

export default connect(
  (
    state: ApplicationState,
    ownProps: MavoVehicleDetailsProps
  ) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app,
    vehicleState: state.vehicle,
    mavoVehicle: state.mavoVehicle,
    ...ownProps
  }),
  { ...CaseSettingsActionCreators, ...VehicleActionCreators, ...MavoVehicleActionCreators }
)(withSnackbar(MavoAttachmentDataContainer as any));
